import React from 'react';
import styles from './Card.module.css';

const Card = ({ title,type, date, text, link }) => {
  return (
    <div className={styles.Card} onClick={() => window.open(link, "_blank")}>
      <div className={styles.title}>{title}</div>
      <div className={styles.date}>{date}</div>
      <div className={styles.text}>{text}</div>
      <div className={styles.type}>{type}
      <button className={styles.button} onClick={() => window.open(link, "_blank")}>{'Vai al sito'}</button>
    </div>
    </div>
  );
};

export default Card;